module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "slider",
    staticClass: "pp-mobile-cover-art-slider",
    on: {
      "scroll": _vm.onScroll,
      "touchstart": _vm.onTouchStart,
      "touchmove": _vm.onTouchMove
    }
  }, [_vm._l((_vm.nearHistory), function(track) {
    return _c('div', {
      staticClass: "pp-mobile-cover-art-slider__slide"
    }, [_c('img', {
      attrs: {
        "src": track.album.artwork
      }
    })])
  }), _vm._v(" "), (_vm.currentTrack) ? _c('a', {
    staticClass: "pp-mobile-cover-art-slider__slide pp-mobile-cover-art-slider__slide--current",
    attrs: {
      "href": _vm.href,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.currentTrack.album.artwork
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.nearQueue), function(track) {
    return _c('div', {
      staticClass: "pp-mobile-cover-art-slider__slide"
    }, [_c('img', {
      attrs: {
        "src": track.album.artwork
      }
    })])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-541b2231","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileCoverArtSlider.vue
// module id = 174
// module chunks = 0